(function () {
  if (!window.location.pathname.endsWith('/collections/tweezers')) {
    return;
  }

  const pagination = document.querySelector('.pagination-wrapper');
  const gridContainer = document.getElementById('ProductGridContainer');

  function getGridItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return [];
    }

    return [...grid.querySelectorAll('.grid__item[data-ovs-tweezer-style]')];
  }

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedValues(selector, attribute) {
    const values = new Set();

    document.querySelectorAll(selector).forEach((input) => {
      if (!input.checked) {
        return;
      }

      const value = input.getAttribute(attribute) || '';
      if (value !== '') {
        values.add(value);
      }
    });

    return [...values];
  }

  function selectedLines() {
    return selectedValues('.ovs-tweezer-line-input:checked', 'data-ovs-tweezer-line');
  }

  function selectedStyles() {
    return selectedValues('.ovs-tweezer-style-input:checked', 'data-ovs-tweezer-style');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-tweezer-line-input').forEach((input) => {
      const label = input.closest('.ovs-tweezer-line-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-tweezer-style-input').forEach((input) => {
      const label = input.closest('.ovs-tweezer-style-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncPanels(changedInput, attribute) {
    const value = changedInput.getAttribute(attribute) || '';
    if (value === '') {
      return;
    }

    document.querySelectorAll(`[${attribute}="${value}"]`).forEach((input) => {
      input.checked = changedInput.checked;
    });
  }

  function syncCheckboxesFromUrl() {
    const lines = parseList('ovs_tweezer_line');
    const styles = parseList('ovs_tweezer_style');

    document.querySelectorAll('.ovs-tweezer-line-input').forEach((input) => {
      const line = input.getAttribute('data-ovs-tweezer-line') || '';
      input.checked = lines.includes(line);
    });

    document.querySelectorAll('.ovs-tweezer-style-input').forEach((input) => {
      const style = input.getAttribute('data-ovs-tweezer-style') || '';
      input.checked = styles.includes(style);
    });

    syncCheckboxLabels();
  }

  function buildUrl(lines, styles) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_tweezer_line');
    url.searchParams.delete('ovs_tweezer_style');
    url.searchParams.delete('page');

    if (lines.length > 0) {
      url.searchParams.set('ovs_tweezer_line', lines.join(','));
    }

    if (styles.length > 0) {
      url.searchParams.set('ovs_tweezer_style', styles.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(lines, styles) {
    if (!pagination) {
      return;
    }

    pagination.hidden = lines.length > 0 || styles.length > 0;
  }

  function setItemVisibility(item, show) {
    item.hidden = !show;
    item.classList.toggle('hidden', !show);
    item.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function filtersActive() {
    return selectedLines().length > 0 || selectedStyles().length > 0;
  }

  function applyFilters(updateHistory) {
    const lines = selectedLines();
    const styles = selectedStyles();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemLine = item.getAttribute('data-ovs-tweezer-line') || '';
      const itemStyle = item.getAttribute('data-ovs-tweezer-style') || '';
      let show = true;

      if (lines.length > 0) {
        show = itemLine !== '' && lines.includes(itemLine);
      }

      if (show && styles.length > 0) {
        show = itemStyle !== '' && styles.includes(itemStyle);
      }

      setItemVisibility(item, show);
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(lines, styles);

    if (updateHistory) {
      const url = buildUrl(lines, styles);
      window.history.pushState({ ovsTweezerFilters: true }, '', url.pathname + url.search);
    }
  }

  function stopFacetFormPropagation(event) {
    event.stopPropagation();
  }

  document.querySelectorAll('.ovs-tweezer-line-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input, 'data-ovs-tweezer-line');
      applyFilters(true);
    });
  });

  document.querySelectorAll('.ovs-tweezer-style-input').forEach((input) => {
    input.addEventListener('input', stopFacetFormPropagation);
    input.addEventListener('change', (event) => {
      stopFacetFormPropagation(event);
      syncPanels(input, 'data-ovs-tweezer-style');
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  if (gridContainer) {
    const observer = new MutationObserver(() => {
      if (filtersActive()) {
        applyFilters(false);
      }
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
